import Toggle from './Toggle.js'
import Select from './Select.js'

export default {
    toggle: Toggle,
    select: Select,
}
